import "core-js/modules/es.array.find-last-index.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  "class": "scroll-button-text"
};
import { ref, computed, onMounted, onUnmounted } from "../../../../adapter-vue";
import { TUIStore, StoreName, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import Icon from "../../../common/Icon.vue";
import doubleArrowIcon from "../../../../assets/icon/double-arrow.svg";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["scrollToLatestMessage"],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var emits = __emit;
    var messageList = ref([]);
    var currentLastMessageTime = ref(0);
    var isScrollOverOneScreen = ref(false);
    onMounted(function () {
      TUIStore.watch(StoreName.CHAT, {
        messageList: onMessageListUpdated
      });
      TUIStore.watch(StoreName.CONV, {
        currentConversation: getLatestMessageTime
      });
    });
    onUnmounted(function () {
      TUIStore.unwatch(StoreName.CHAT, {
        messageList: onMessageListUpdated
      });
      TUIStore.unwatch(StoreName.CONV, {
        currentConversation: getLatestMessageTime
      });
    });
    // TODO
    var isExistLatestMessage = computed(function () {
      var _messageList$value, _messageList$value$la;
      var lastSuccessMessageIndex = (_messageList$value = messageList.value) === null || _messageList$value === void 0 ? void 0 : _messageList$value.findLastIndex(function (message) {
        return message.status === "success";
      });
      return lastSuccessMessageIndex && (messageList === null || messageList === void 0 || (_messageList$value$la = messageList.value[lastSuccessMessageIndex]) === null || _messageList$value$la === void 0 ? void 0 : _messageList$value$la.time) < (currentLastMessageTime === null || currentLastMessageTime === void 0 ? void 0 : currentLastMessageTime.value);
    });
    function onMessageListUpdated(newMessageList) {
      messageList.value = newMessageList || [];
    }
    function getLatestMessageTime(conversation) {
      var _conversation$lastMes;
      currentLastMessageTime.value = (conversation === null || conversation === void 0 || (_conversation$lastMes = conversation.lastMessage) === null || _conversation$lastMes === void 0 ? void 0 : _conversation$lastMes.lastTime) || 0;
    }
    // 消息列表向上的滚动高度大于一屏时，展示滚动到最新
    function judgeScrollOverOneScreen(e) {
      var _e$target;
      if (typeof ((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.scrollTop) === "number") {
        var scrollListDom = e.target;
        var _ref2 = scrollListDom.getBoundingClientRect() || {},
          height = _ref2.height;
        var scrollHeight = scrollListDom.scrollHeight,
          scrollTop = scrollListDom.scrollTop;
        if (height && scrollHeight) {
          if (scrollTop < scrollHeight - 2 * height) {
            isScrollOverOneScreen.value = true;
          } else {
            isScrollOverOneScreen.value = false;
          }
        }
      }
    }
    // 载入最新的 messageSource
    function resetMessageSource() {
      if (TUIStore.getData(StoreName.CHAT, "messageSource") !== undefined) {
        TUIStore.update(StoreName.CHAT, "messageSource", undefined);
      }
    }
    // 滚动到消息列表最底部
    function scrollToMessageListBottom() {
      resetMessageSource();
      setTimeout(function () {
        return emits("scrollToLatestMessage");
      }, 100);
    }
    __expose({
      judgeScrollOverOneScreen: judgeScrollOverOneScreen
    });
    return function (_ctx, _cache) {
      return _unref(isExistLatestMessage) || _unref(isScrollOverOneScreen) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "scroll-button",
        onClick: scrollToMessageListBottom
      }, [_createVNode(Icon, {
        width: "10px",
        height: "10px",
        file: _unref(doubleArrowIcon)
      }, null, 8, ["file"]), _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(TUITranslateService).t("TUIChat.回到最新位置")), 1)])) : _createCommentVNode("", true);
    };
  }
});